import React from 'react';
import { createStyles, WithStyles, withStyles } from '@material-ui/core';

import { UnloggedLayout } from '../layouts/UnloggedLayout';
import { Box } from '../Box';
import { BoxHeader } from '../BoxHeader';
import { useTranslator } from '../../i18n/useTranslator';
import { useHistory } from 'react-router';
import { Button } from '../Button';
import { HelpMessage } from '../HelpMessage';

const styles = () =>
  createStyles({
    loginButton: {
      marginTop: 20,
    },
  });

type Props = WithStyles<typeof styles>;

const PasswordResetEmailSentScreenComponent: React.FunctionComponent<Props> = ({ classes }) => {
  const { t } = useTranslator();

  const history = useHistory();
  const { email } = history.location.state as any;

  return (
    <UnloggedLayout>
      <Box>
        <BoxHeader title={t('linkSent')} />
        <div>{t('resetPasswordMessage1')} <b>{email}</b></div>
        <div>{t('resetPasswordMessage2')}</div>
        <br/>
        <Button to={'/login'} fullWidth variant={'outlined'}>
          {t('login')}
        </Button>
        <HelpMessage />
      </Box>
    </UnloggedLayout>
  );
};

export const PasswordResetEmailSentScreen = withStyles(styles)(PasswordResetEmailSentScreenComponent);
